import { toASCII } from "../../../helpers";
import { Say } from "../../../languages";
import QrCode from "../../Shared/QrCode";

export function OrderConfirmationBoothQRCode({
  visible = true,
  currentOrder,
  toggleBoothComplete
}) {
  if (!visible) {
    return null;
  }

  const { firstName, lastName, orderId } = currentOrder;
  const qrCodeData = ["ORD", orderId, toASCII([firstName, lastName].join(" "))].join("|");

  return (
    <div className="order-confirmation__booth-qr">
      <p>
        <Say phrase="chosen.thank_you.qr_message" />
      </p>
      <QrCode data={qrCodeData} />
      <button
        className="link-like__button"
        data-target="internal_link"
        data-info={`chosen.thank_you.photo_received_cta:${window.location.href}`}
        data-type="text"
        onClick={() => toggleBoothComplete(true)}>
        <strong>
          <Say phrase="chosen.thank_you.photo_received_cta" />
        </strong>
      </button>
    </div>
  );
}

export default OrderConfirmationBoothQRCode;
